<template>
    <section class="o-page-bottom-spacing--medium">

        <page-header>
            <slot slot="title">{{ $t('available_preorder_overview.page_title') }}</slot>
            <slot slot="description">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/pre-orders/create">{{ $t('preorder_fiche.create') }}</router-link>
            </slot>
        </page-header>

        <v-overview-list
            prefix="a1"
            data-table="PreOrderSheets"
            data-filter="PreOrderSheetsFilters"
            data-pagination="PreOrderSheetsPagination"
            btnViewPath="AdminPreOrdersEdit"
            :filters="Filters"
            :table-columns="Columns"
            :btn-copy="true"
            :page-size="12">

            <template slot="placeholderButtonsFooter">
                <router-link class="[ c-button c-button--alpha ]" to="/admin/pre-orders/create">{{ $t('preorder_fiche.create') }}</router-link>
            </template>
        </v-overview-list>

    </section>
</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VSelect from '@/components/form/Select'
    import VOverviewList from '@/components/OverviewList'

    export default {
        components: {
            PageHeader,
            VSelect,
            VOverviewList
        },
        data() {
          return { }
        },
        computed: {
            Filters() { 
                return [
                    {
                        name: this.$t('preorder_overview.filters.brands'), 
                        value: 'Brands',
                        single: 'brand',
                        width:150
                    },
                    {
                        name: this.$t('preorder_overview.filters.collections'),
                        value: 'Collections',
                        single: 'collection',
                        width:150
                    },
                    {
                        name: this.$t('preorder_overview.filters.states'),
                        value: 'States',
                        single: 'state',
                        width:150
                    }
                ];
            },
            Columns() {
                return [
                  {
                      value: 'Name',
                      name: this.$t('preorder_overview.columns.name')
                  },
                  {
                      value: 'StartDate',
                      name: this.$t('preorder_overview.columns.startdate'),
                      type: 'Date'
                  },
                  {
                      value: 'State',
                      name: this.$t('preorder_overview.columns.state')
                  },
                  {
                      value: 'Deadline',
                      name: this.$t('preorder_overview.columns.deadline'),
                      type: 'Date'
                  },
                  {
                      value: 'LastUpdate',
                      name: 'Laatste update',
                      type: 'Date'
                  },
                  {
                      value: 'ProductCount',
                      name: this.$t('preorder_overview.columns.product_count')
                  },
                  {
                      value: 'AssignedCustomers',
                      name: this.$t('preorder_overview.columns.assigned_customers')
                  }
              ];
            }
        },
        methods: {}
    }

</script>



// WEBPACK FOOTER //
// src/views/admin/preOrders/AvailableFiches.vue